import React from 'react';

import { CustomRoute } from 'util/hook/useRouter';
import { appPath } from 'util/routingConfig';

const routes: CustomRoute = {
	path: appPath.rentalBikesFees.replace(appPath.rental, ''),
	components: () => [import(/* webpackChunkName: 'rentalBikesFees' */ './component')],
	render: ([RentalBikesFees]) => <RentalBikesFees />,
};

export default routes;
